import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getHierarchies } from "api";
import _ from "lodash";

export const fetchRcs = createAsyncThunk(
	"assetRc/fetchRcs",
	async ({ code, stateKey }, { rejectWithValue }) => {
		try {
			//code = parent division containing RCs we want

			const data = await getHierarchies({
				code,
				domain: "Test", //org hierarchy
				viewOption: "Children", //show RCs only
			});
			return { data, stateKey };
		} catch (error) {
			console.log(error.message);
			return rejectWithValue({
				title: error.name,
				message: error.message,
			});
		}
	}
);

const initialState = {
	rcs: [],
	mentalHealthRcs: [], //used to determine workflows
	facilityRcs: [], //same as above
	status: "idle",
	error: null,
};

const assetRcSlice = createSlice({
	name: "assetRc",
	initialState,
	reducers: {
		rcsReceived(state, action) {
			state.rcs = action.payload;
		},
	},
	extraReducers: {
		[fetchRcs.pending]: (state, action) => {
			state.status = "loading";
		},
		[fetchRcs.fulfilled]: (state, action) => {
			state.status = "idle";
			const { data, stateKey } = action.payload;
			const sortedRcs = _.orderBy(data, ["code"], ["asc"]);
			state[stateKey] = sortedRcs;
		},
		[fetchRcs.rejected]: (state, action) => {
			state.status = "failed";
			state.error = action.payload;
			state.rcs = [];
		},
	},
});

export const { rcsReceived } = assetRcSlice.actions;

export const selectAssetRc = (state) => state.capex.assetRc.rcs;
export const selectMentalHealthRcs = (state) =>
	state.capex.assetRc.mentalHealthRcs;
export const selectFacilityRcs = (state) => state.capex.assetRc.facilityRcs;

export default assetRcSlice.reducer;
